import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import CognitoFormInternalFormScreen from '../components/CognitoFormInternalFormScreen';
import {
  loadCognitoFormAnswers,
  deleteCognitoFormAnswer,
  generateCognitoFormAnswerPDF,
} from '../../../../../state/modules/cognitoFormAnswers/actions';

const mapStateToProps = (state, ownProps) => {
  const partnershipId = ownProps.partnershipId;
  const careGuideId = ownProps.careGuideId;
  const cognitoFormId = ownProps.cognitoFormId;
  const page = ownProps.page ?? 1;
  const limit = ownProps.limit ?? 10;
  const order = ownProps.order ?? 'created_at.desc';

  const result = state.cognitoFormAnswers.getIn([
    'pages',
    partnershipId,
    careGuideId,
    cognitoFormId,
    page,
    limit,
    order,
  ]);

  return {
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['cognitoFormAnswers', x]),
                schema.cognitoFormAnswer,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
      : [],
    isLoading: state.cognitoFormAnswers.get('isLoading'),
    total: state.cognitoFormAnswers.get('total'),
    isGeneratingPDF: state.cognitoFormAnswers.get('isGeneratingPDF'),
    page,
    limit,
    order,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      partnershipId,
      careGuideId,
      cognitoFormId,
      page,
      limit,
      order,
      filter,
      cb
    ) => {
      dispatch(
        loadCognitoFormAnswers(
          partnershipId,
          careGuideId,
          cognitoFormId,
          page,
          limit,
          order,
          filter,
          cb
        )
      );
    },
    remove: (partnershipId, careGuideId, id, cb) => {
      dispatch(deleteCognitoFormAnswer(partnershipId, careGuideId, id, cb));
    },
    generatePDF: (partnershipId, careGuideId, id, cb) => {
      dispatch(
        generateCognitoFormAnswerPDF(partnershipId, careGuideId, id, cb)
      );
    },
  };
};

const CognitoFormInternalFormScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormInternalFormScreen);

export default CognitoFormInternalFormScreenContainer;
